import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SkeletonComponent } from './skeleton.component';
import { SkeletonListComponent } from './skeleton-list.component';

@NgModule({
  declarations: [SkeletonComponent, SkeletonListComponent],
  exports: [SkeletonComponent, SkeletonListComponent],
  imports: [CommonModule],
})
export class SkeletonModule {}
